export const locations = {
    SEARCH_BROWSE: 'SEARCH_BROWSE',
};

export const authLabels = {
    SEARCH_BROWSE: 'save search - search/browse page',
};
